module.exports = __webpack_public_path__ + "static/media/High Flight.5e7cffd4.jpg";